export default {
  getVesselId: state => {
    return state.vesselInfo.id;
  },
  getChannelInfo: state => channelId => {
    return state.channelMaster.find(element => element.channel_id === channelId);
  },
  hasChannelMaster: state => {
    return state.channelMaster !== null
  },
};
